<pux-icon class="text-color-remove" v-if="statusShow" :icon="'warning'" icon-tooltip="_TXT_NUTZER_GESPERRT_ICON_NUTZER_GESPERRT_"></pux-icon>